import React from "react";
import InfoSection from "../common/InfoSection";
import { flowData } from "../../constants/data";
import arrowIcon from "../../assets/arrow.svg";
import { Link } from "react-router-dom";

function RegTechFlow() {
  return (
    <div className="max-w-1200 mx-auto w-full">
      <div className="px-4 sm:px-6 lg:px-0">
        <div className="flex flex-col gap-8">
          <InfoSection
            title="Our Solutions"
            subtitle="RegTechFlow Solutions"
            descriptionhead="RegTechFlow"
            description="we help businesses of all sizes and industries automate their corporate, licensing, and compliance management. Our platform reduces repetitive tasks and ensures you stay compliant with minimal effort. Explore our solutions that simplify your business processes, allowing you to focus on growth while we handle the details."
            additionalText=""
            width="max-w-4xl"
          />
          <div className="flex flex-col font-poppins gap-4">
            {flowData.map((flow, idx) => {
              return (
                <div
                  key={flow.head}
                  className={`flex ${
                    idx % 2 === 0
                      ? "lg:flex-row-reverse flex-col-reverse"
                      : "lg:flex-row flex-col-reverse"
                  } lg:items-center gap-10 sm:gap-[32px] sm:mt-[64px]`}
                >
                  <div className="md:min-w-[411px] max-lg:mx-auto md:max-w-[411px]"> 
                    <img
                      src={flow.icon}
                      alt={flow.icon}
                      width={500}
                      height={500}
                      className="object-cover"
                    />
                  </div>
                  <div
                    className={`flex ${
                      idx % 2 === 0 ? "items-end" : "md:items-start"
                    } flex-col gap-2`}
                  >
                    <div className="text-darkGray font-bold text-xl">
                      {flow.head}
                    </div>
                    <div
                      className={`text-darkGray/70 font-normal text-base sm:text-sm leading-7 ${
                        idx === flowData.length - 1 ? "w-full" : "md:w-11/12"
                      } ${
                        idx % 2 === 0
                          ? "text-right md:pl-5"
                          : "text-left"
                      } `}
                    >
                      {flow.description}
                    </div>
                    {flow.points && (
                      <div>
                        <ul className="list-disc pl-6 space-y-2">
                          {flow.points.map((point) => (
                            <li
                              key={point}
                              className={`text-left text-darkGray/70 marker:text-[#67DC7A] marker:text-2xl marker:leading-6 font-medium text-sm leading-7`}
                            >
                              {point}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    <Link to={flow.path} className="flex items-center gap-2 mt-2 cursor-pointer">   
                      <div className="text-darkPurple font-semibold text-sm leading-7">
                        Learn More
                      </div>
                      <img src={arrowIcon} height={16} width={16} alt="arrow" />
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegTechFlow;
